import request from '@/utils/request'


// 查询科普文章列表
export function listPopularize(query) {
  return request({
    url: '/popularize/popularize/list',
    method: 'get',
    params: query
  })
}

// 查询科普文章分页
export function pagePopularize(query) {
  return request({
    url: '/popularize/popularize/page',
    method: 'get',
    params: query
  })
}

export function popularizeUpdateSort(data) {
  return request({
    url: '/popularize/popularize/updateSort',
    method: 'post',
    data: data
  })
}
// 查询科普文章分页


// 查询科普文章详细
export function getPopularize(data) {
  return request({
    url: '/popularize/popularize/detail',
    method: 'get',
    params: data
  })
}

// 新增科普文章
export function addPopularize(data) {
  return request({
    url: '/popularize/popularize/add',
    method: 'post',
    data: data
  })
}

// 修改科普文章
export function updatePopularize(data) {
  return request({
    url: '/popularize/popularize/edit',
    method: 'post',
    data: data
  })
}
export function copyPopularize(data) {
  return request({
    url: '/popularize/popularize/copyPopularize',
    method: 'get',
    params: data
  })
}
// 删除科普文章
export function delPopularize(data) {
  return request({
    url: '/popularize/popularize/delete',
    method: 'post',
    data: data
  })
}
